import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listCategorias: [],
  categoria_selected: {},
  categorias: []
};
export const mutations = {
  GET_CATEGORIAS({ context }, list_categorias) {
    let categorias = [];
    Object.entries(list_categorias).forEach(([key, val]) => categorias.push(val));
    return (state.listCategorias = categorias);
  },
  SELECT_CATEGORIA({ context }, categoria) {
    return (state.categoria_selected = Object.assign({}, categoria));
  },
  FILL_CATEGORIAS({ context }, list_categorias) {
    let categorias = [];
    Object.entries(list_categorias).forEach(([key, val]) => categorias.push(val));
    return (state.categorias = categorias);
  }
};
export const actions = {
  GET_CATEGORIAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("CLEAR_NOTIFICATION");
          commit("GET_CATEGORIAS", response.data.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  GET_ALL_CATEGORIAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_CATEGORIAS", response.data.data.categorias);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  GET_TIPO_DOCUMENTO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          // commit("CLEAR_NOTIFICATION");
          // commit("GET_TIPO_DOCUMENTO", response.data.data);
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_CATEGORIA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_CATEGORIA({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_CATEGORIA({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};

export const getters = {
  listCategorias: state => state.listCategorias,
  getAllCategorias: state => {
    return state.categorias;
  }
};
